/* global $ */
import React, { useState, useEffect } from "react";
import api from "../../../services/api";
import { showToast } from '../../../utils/toastUtils';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { getRegistryCredentials } from '../../../utils/registryUtils';
import Cookies from 'js-cookie';

const GuestbookModal = () => {
  const [loading, setLoading] = useState(false);
  const [guestFirstName, setGuestFirstName] = useState("");
  const [guestLastName, setGuestLastName] = useState("");
  const [guestEmail, setGuestEmail] = useState("");
  const [guestMessage, setGuestMessage] = useState("");
  const [remainingChars, setRemainingChars] = useState(500);
  const [isFormValid, setIsFormValid] = useState(false);
  const { registryId, guestbookSigned } = getRegistryCredentials();
  const { executeRecaptcha } = useGoogleReCaptcha();

  useEffect(() => {
    const validateForm = () => {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      
      const isValid =
        guestFirstName.trim() !== "" &&
        guestLastName.trim() !== "" &&
        guestEmail.trim() !== "" &&
        emailPattern.test(guestEmail) &&
        guestMessage.trim() !== ""  
      setIsFormValid(isValid);
    };
  
    validateForm();
  }, [guestFirstName, guestLastName, guestEmail, guestMessage]);
  
  const handleFirstNameChange = (e) => {
    setGuestFirstName(e.target.value);
  };

  const handleLastNameChange = (e) => {
    setGuestLastName(e.target.value);
  };

  const handleEmailChange = (e) => {
    setGuestEmail(e.target.value);
  };

  const handleMessageChange = (e) => {
    const value = e.target.value;
    setGuestMessage(value);
    setRemainingChars(500 - value.length);
  };

  const handleSubmit = async () => {
    if (isFormValid) {
      if (!executeRecaptcha) {
        showToast('reCAPTCHA not ready, please try again');
        return;
      }

      setLoading(true);
      try {
        const recaptchaToken = await executeRecaptcha('guestbook_submission');
        const guestName = `${guestFirstName} ${guestLastName}`;
        await api.guestDiaryEntry(guestName, guestMessage, guestEmail, registryId, recaptchaToken);

        Cookies.set('guestbookSigned', true, { expires: 30, sameSite: 'None', secure: true });
        localStorage.setItem('guestbookSigned', true);
        resetGuestBook();
        showToast('Guestbook signed successfully!', "success");
        $("#guest-book").modal("hide");
      } catch (error) {
        showToast(error.message || 'Error signing guestbook', "error");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleGuestBookCancel = () => {
    if(!guestbookSigned){
      resetGuestBook();
    }
  };

  const resetGuestBook = () => {
    setGuestFirstName("");
    setGuestLastName("");
    setGuestEmail("");
    setGuestMessage("");
    setRemainingChars(500);
    setIsFormValid(false);
  };

  return (
    <div className="modal fade" id="guest-book" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog common-popup purchaser-details-popup">
        <div className="modal-content">
          <div className="modal-header">
            {guestbookSigned ? <p>GUESTBOOK</p> : <p>SIGN OUR GUESTBOOK</p>}
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleGuestBookCancel}></button>
          </div>
          <div className="modal-body login-box row">
          {guestbookSigned ? (
            <p className="mt-5 mb-5 fs-5 text-center">You have already signed this guestbook.</p>
          ) : (
            <div className="product-form mt-3">
            <h5 className="mb-3">SIGN GUESTBOOK</h5>
              <form noValidate>
                <div className="user-box product-field">
                  <div className="product-column">
                    <input
                      type="text"
                      name="firstName"
                      value={guestFirstName}
                      onChange={handleFirstNameChange}
                      required
                    />
                    <label>First Name</label>
                  </div>
                  <div className="product-column">
                    <input
                      type="text"
                      name="lastName"
                      value={guestLastName}
                      onChange={handleLastNameChange}
                      required
                    />
                    <label>Last Name</label>
                  </div>
                </div>

                <div className="user-box">
                  <input
                    type="email"
                    name="email"
                    value={guestEmail}
                    onChange={handleEmailChange}
                    required
                  />
                  <label>Your Email</label>
                </div>

                <label className="mb-1">Your Message</label>
                <div className="user-box mb-4">
                  <textarea
                    id="message"
                    name="Message"
                    placeholder="Enter Message here..."
                    value={guestMessage}
                    onChange={handleMessageChange}
                    maxLength={500}
                  />
                  <div className="char-count">
                    {remainingChars} characters left
                  </div>
                </div>
              </form>
              <button
                type="button"
                className={`btn form-btn edit-gift-btn guestbook-btn mx-auto my-2`}
                onClick={handleSubmit}
                disabled={!isFormValid || loading}
              >
               {loading ? "SUBMITTING..." : "SUBMIT"}
              </button>
              <p className="recaptcha-disclaimer mt-3">
                This site is protected by reCAPTCHA and the Google
              </p>
            </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuestbookModal;